// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--EYRLd","menu":"menu--NMBzD"};